//a page to be displayed inside antd version 4 modal for retrieveing lost password with the header title "Forgot Password". The user is required to input their email and a button below to submit the request. On submission, a message should be displayed informing the user that if the email exists, a reset link has been sent.
import React, { useState } from 'react';
import { Form, Input, Button, Modal } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { THEME_PALLETE } from '../../Theme';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet, requestWarroomServerGet } from '../../actions';
import PopupManager from '../../managers/PopupManager';

const ForgotPasswordPopup = (props) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleFinish = (values) => {
        const { email } = values;
        const {requestServerPost, usertoken} = props;

        const params = new FormData();
        params.append("email", email)

        setLoading(true);

        requestServerPost("forget_password", params, {}, (response) => {
            PopupManager.closePopup();
            Modal.success({
                title: 'Check your email',
                content: 'If the email exists, a temporary password has been sent.',
            });
        }, usertoken, {}, () => {
            setLoading(false);
        });
    };

    return (
        <div style={{ padding: '32px', width: '100%', boxSizing: 'border-box' }}>
            <div
                style={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    background: THEME_PALLETE.gradientPrimarySoft,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: 20,
                }}
            >
                <LockOutlined style={{ fontSize: 22, color: THEME_PALLETE.primary }} />
            </div>

            <h2 style={{ margin: 0, color: THEME_PALLETE.textHeading, fontSize: 22, fontWeight: 700 }}>Forgot Password</h2>
            <div style={{ color: THEME_PALLETE.textSecondary, marginTop: 6, marginBottom: 28, fontSize: 14, lineHeight: 1.5 }}>
                Enter your email address and we'll send you a temporary password.
            </div>

            <Form form={form} onFinish={handleFinish} layout="vertical" requiredMark={false}>
                <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                        { required: true, message: 'Please input your email!' },
                        { type: 'email', message: 'Please enter a valid email!' }
                    ]}
                >
                    <Input
                        prefix={<MailOutlined style={{ color: THEME_PALLETE.textMuted }} />}
                        placeholder="Enter your email"
                        disabled={loading}
                        size="large"
                        style={{ borderRadius: THEME_PALLETE.radiusSm }}
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        block
                        size="large"
                        style={{
                            borderRadius: THEME_PALLETE.radiusSm,
                            background: THEME_PALLETE.gradientPrimary,
                            border: 'none',
                            fontWeight: 600,
                            height: 44,
                        }}
                    >
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestWarroomServerGet, requestServerPost, selectPage, requestNodeServerPost })(ForgotPasswordPopup);